import {Action, getModule, Module, Mutation, MutationAction, VuexModule} from "vuex-module-decorators";
import store from "@/store"
import {LadingCareState} from "@/interfaces/state/ladingcare";
import {IdMapper} from "@/interfaces/state/base";
import {LadingCare} from "@/interfaces/entity/ladingcare";
import {LadingCareParams} from "@/modules/ladingcare/params";
import {PaginationMeta} from "@/interfaces/common";
import {createLadingCare, listLadingCare, singleLadingCare, updateLadingCare} from "@/modules/ladingcare/services";

@Module({dynamic: true, name: "ladingCare", store})
class LadingCareModule extends VuexModule implements LadingCareState {
    data: IdMapper<LadingCare> = {};
    ids: number[] = [];
    meta: PaginationMeta = new PaginationMeta();
    params: LadingCareParams = new LadingCareParams;

    get ladingCare() {
        return this.ids.map((id: number) => this.data[id]);
    }

    @Mutation
    private UPDATE_LADING_CARE_PARAMS(payload: any) {
        this.params = payload
    }

    @Mutation
    private UPDATE_LADING_CARE(payload: LadingCare) {
        if(!this.data[payload.id] || !this.ids.includes(payload.id)) return;
        this.data[payload.id] = {...payload}
    }
    @Mutation
    private MAP_LADING_CARE(payload: any) {
        const idMapper: IdMapper<LadingCare> = {};
        this.meta = payload.meta;
        this.ids = payload.datas?.map((ladingCare: LadingCare) => {
            idMapper[ladingCare.id!] = {...ladingCare};
            return ladingCare.id;
        });
        this.data = idMapper;
    }

    @Mutation
    private ADD_LADING_CARE(payload: LadingCare){
        if (!payload || this.ids.includes(payload.id) || this.data[payload.id]) return;
        this.ids =  [...this.ids, payload.id];
        this.data = {...this.data, [payload.id]: {...payload}}
    }

    @Action
    public async createLadingCare(form: any) {
        const {data} = await createLadingCare(form)
        this.ADD_LADING_CARE(data.data)
    }
    @Action
    public async listLadingCare(params: LadingCareParams = new LadingCareParams()) {
        const {data} = await listLadingCare(params);
        this.MAP_LADING_CARE(data);
    }

    @Action
    public updateLadingCareParams(payload: any) {
        this.UPDATE_LADING_CARE_PARAMS(payload);
    }

    @Action
    public async singleLadingCare(id: number) {
        const {data} = await singleLadingCare(id);
        return data.data;
    }

    @Action
    public async updateLadingCare(dataReq: any) {
        const {data} = await updateLadingCare(dataReq.id, dataReq);
        this.UPDATE_LADING_CARE(data.data);
    }
}

export const LadingCareStore = getModule(LadingCareModule)
